import { cockpitExplorerService } from "@/api";

const initialState = {
  businessStatuses: [],
};

export default {
  namespaced: true,

  state: () => ({ ...initialState }),

  getters: {
    businessStatuses: (state) => state.businessStatuses,
  },

  mutations: {
    setBusinessStatuses(state, statuses) {
      statuses.sort((a, b) => a.name.localeCompare(b.name));
      state.businessStatuses = statuses;
    },
  },

  actions: {
    async fetchBusinessStatuses({ commit, state }, { isRefresh = false } = {}) {
      if (state.businessStatuses.length && !isRefresh) {
        return;
      }

      const resp = await cockpitExplorerService.v2.getBusinessStatuses();
      commit("setBusinessStatuses", resp.businessStatuses);
    },
  }
}
